import { FlashMeetingIcon, KamishibaiIcon, ResolutionIcon, UmanforgeIcon } from '@umanforge/common';
import { LinkToApp } from './link_to_app.component';

const LinkToApps: React.FC = () => {
  return (
    <div className='overflow-hidden whitespace-nowrap flex flex-col gap-2 dark:bg-dark-bg-light absolute appear-jump
      bottom-[60px] left-0 bg-white shadow-2xl drop-shadow-lg p-2 rounded-lg transition-all duration-300'
    >
      <LinkToApp appKey="UMANFORGE" icon={UmanforgeIcon} />
      <LinkToApp appKey="FLASHMEETING" icon={FlashMeetingIcon} />
      <LinkToApp appKey="KAMISHIBAI" icon={KamishibaiIcon} />
      <LinkToApp appKey="RESOLUTION" icon={ResolutionIcon} />
    </div>
  );
};

export { LinkToApps };